import { useState, useEffect } from 'react';
import { iso1A2Code, callingCodes } from '@ideditor/country-coder';

interface Code {
  country: string | null;
  tel: string | null;
}

const useGeolocation = () => {
  const [position, setPosition] = useState<GeolocationPosition | null>(null);
  const [code, setCode] = useState<Code>({ country: null, tel: null });

  /**
   * @callback
   * @param {GeolocationPosition} position
   * navigator.geolocation.getCurrentPosition:success
   */
  const success: PositionCallback = (position) => {
    setPosition(position);

    const { longitude, latitude } = position.coords;
    const countryCode = iso1A2Code([longitude, latitude]);

    let telCode: string | null = null;

    if (countryCode) {
      telCode = callingCodes(countryCode)[0] || null;
    }

    setCode({
      country: countryCode,
      tel: telCode,
    });
  };

  /**
   * @callback
   * @param {GeolocationPositionError} e
   * navigator.geolocation.getCurrentPosition:error
   */
  const error: PositionErrorCallback = (e) => {
    console.log(e);
  };

  useEffect(() => {
    /** geolocation logic */
    if ('geolocation' in navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'granted' || result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(success, error);
        }

        if (result.state === 'denied') {
          // revoke 의 deprecated 로 인해 재요청 불가
          // 크롬에서 직접 설정해줘야함
        }
      });
    }
  }, []);

  return {
    position,
    code,
  };
};

export default useGeolocation;
